export type NavLink = { name: string; path: string };

export const leftLinks: NavLink[] = [
  { name: 'Dashboard', path: '/dashboard' }
];

export const rightLinks: NavLink[] = [
  { name: 'Market Movers', path: '/market-movers' },
  { name: 'News', path: '/news' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'About', path: '/about' }
];

export const toolLinks: NavLink[] = [
  { name: 'Chart Analysis', path: '/chart-analysis' },
  { name: 'Screener', path: '/screener' },
  { name: 'Compare Stocks', path: '/compare' },
  { name: 'Investment Goal', path: '/investment-goal' },
  { name: 'Hall of Fame', path: '/hall-of-fame' }
];

export const insightLinks: NavLink[] = [
  { name: 'Fund-Level', path: '/fund-insights' },
  { name: 'Earnings', path: '/earnings' }
];

export const resourceLinks: NavLink[] = [
  { name: 'News', path: '/news' },
  { name: 'Screener', path: '/screener' },
  { name: 'Compare Stocks', path: '/compare' },
  { name: 'Market Movers', path: '/market-movers' },
  { name: 'Earnings', path: '/earnings' },
  { name: 'ETFs', path: '/etfs' },
  { name: 'Fund Insights', path: '/fund-insights' },
  { name: 'Insider Trades', path: '/insider-trades' },
  { name: 'Senate Trades', path: '/senate-trades' }
];

export const companyLinks: NavLink[] = [
  { name: 'About', path: '/about' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'Privacy Policy', path: '/privacy-policy' },
  { name: 'Terms of Service', path: '/terms-of-service' }
];
